import { StringArgs, t, tc, tn, tnc, tp } from './core'

export function tf(key: string, args?: StringArgs): string {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Missing translation key:', key)
  }
  return t(key, args)
}

export function tcf(key: string, args?: StringArgs): React.ReactElement {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Missing translation key:', key)
  }
  return tc(key, args)
}

export function tnf(singular: string, plural: string, count?: number, args?: StringArgs): string {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Missing singular translation key:', singular)
    console.warn('Missing plural translation key:', plural)
  }
  return tn(singular, plural, count, args)
}

export function tncf(singular: string, plural: string, count?: number, args?: StringArgs): React.ReactElement {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Missing singular translation key:', singular)
    console.warn('Missing plural translation key:', plural)
  }
  return tnc(singular, plural, count, args)
}

export function tpf(key: string, context: string, args?: StringArgs): string {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Missing translation key:', key, 'for context:', context)
  }
  return tp(key, context, args)
}
